import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaImage from './VaImage.vue'

export const VaImage = withConfigTransport(_VaImage)
